import axiosInstance from './axiosInstance';
import { ApiResponse, CustomError } from './types';

export type PropertyFilter = {
	role: number;
	user_id?: string;
	group_id?: string;
	prop_name?: string;
	// Add more filter properties as needed
};

export const createProperty = async (
	name: string,
	region: string,
	city: string,
	input_sheet: {},
	group_id: string,
	weather_location_id: string,
	latitude: string,
	longitude: string
): Promise<ApiResponse<any>> => {
	const response = await axiosInstance.post(`/v2/admin/properties`, {
		name,
		region,
		city,
		input_sheet,
		weather_location_id,
		latitude,
		longitude,
		group_id,
	});

	return response.data;
};

export const getPropertyList = async (
	group_id: string
): Promise<ApiResponse<any[]>> => {
	// Make the API call to get the list of properties
	const response = await axiosInstance.get(`/v2/g/${group_id}/properties`);

	return response.data;
};

export const getAdminPropertyList = async (
	group_id: string
): Promise<ApiResponse<any[]>> => {
	// Make the API call to get the list of properties
	const response = await axiosInstance.get(`/v2/admin/properties`, {
		params: { group_id },
	});

	return response.data;
};

export const getProperty = async (id: string): Promise<ApiResponse<any[]>> => {
	// Make the API call to get the list of properties
	const response = await axiosInstance.get(`/v2/p/${id}/property`);

	return response.data;
};

export const updateProperty = async (
	id: string,
	dataToUpdate: {}
): Promise<ApiResponse<any>> => {
	// Make the API call to update the property
	const response = await axiosInstance.put(
		`/v2/p/${id}/property`,
		dataToUpdate
	);

	return response.data;
};

export const writeIfOnboardingComplete = async (
	id: string,
	isOnboardingComplete: boolean
): Promise<ApiResponse<any[]>> => {
	// Make the API call to write if onboarding is complete
	const response = await axiosInstance.post(
		`/v2/p/${id}/is-onboarding-complete`,
		isOnboardingComplete
	);
	return response.data;
};

export const getIfUserHasReadOnlyAccess = async (
	property_id: string
): Promise<ApiResponse<any>> => {
	try {
		const response = await axiosInstance.get(
			`/v2/p/${property_id}/check-read-only-access`
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const addUserToProperty = async (
	propertyId: string,
	data: any
): Promise<ApiResponse<any>> => {
	const response = await axiosInstance.post(
		`/v1/properties/${propertyId}/users`,
		data
	);
	return response.data;
};

export const archiveProperty = async (
	propertyId: string,
	data: {}
): Promise<ApiResponse<any>> => {
	try {
		// Make the API call to update the property
		const response = await axiosInstance.delete(
			`/v1/archive-building/${propertyId}`,
			{ data }
		);

		if (response.status !== 204) {
			throw new CustomError(
				'Property could bd not Deleted/archived successfully',
				'DELETE_ERROR',
				response.status
			);
		}

		return response.data;
	} catch (error) {
		throw error;
	}
};

export const findWeatherLocation = async (
	latitude: string,
	longitude: string
): Promise<ApiResponse<any>> => {
	const response = await axiosInstance.post(`/v2/admin/weather-location`, {
		latitude: latitude,
		longitude: longitude,
	});
	return response.data;
};
